import React from 'react';
import PropTypes from 'prop-types';
import { createComponent } from 'cf-style-container';
import propertiesSpec from './propertiesSpec';

var propertyNames = Object.keys(propertiesSpec);

// Generates styles given the provided props.
//
// This is driven by the metadata provided in propertiesSpec
// and produces a data structure like this:
//
// {
//   margin: props.margin || props.theme['margin']
//   width: props.width || props.theme['width']
//   ...
// }
//
// See propertySpec.js for more detail
//
var styles = function styles(props) {
  var styles = {};

  var propKeys = Object.keys(props);

  propKeys.forEach(function (name) {
    // Lookup the spec for the property
    var spec = propertiesSpec[name];

    // Ignore non-style props
    if (spec === undefined) {
      return;
    }

    // Get the style value from props
    var value = props[name];

    // pre-process the value with all pre-processors
    if (spec.preprocessWith) {
      spec.preprocessWith.forEach(function (fn) {
        value = fn(value);
      });
    }

    styles[name] = value;
  });

  // Only do checks in dev mode
  if (process.env.NODE_ENV !== 'production') {
    checkForViolations(styles);
  }

  return styles;
};

var Box = function Box(props) {
  var className = props.className,
      children = props.children;

  // Render the div with the fela classname

  return React.createElement(
    'div',
    { className: className },
    children
  );
};

var checkForViolations = function checkForViolations(props) {
  // Check for conflicts given the spec's conflictsWith property
  // See propertySpec.js for more detail
  propertyNames.forEach(function (propName) {
    var spec = propertiesSpec[propName];
    if (!props[propName] || !spec.conflictsWith) return;

    spec.conflictsWith.forEach(function (otherPropName) {
      if (props[propName] && props[otherPropName]) {
        var msg = propName + ' cannot be set in conjunction with ' + otherPropName;
        console.error(msg);
      }
    });
  });

  // TODO: To pull this check off, we'll need re-evaluate our baseline.
  // current is 22.5px
  // checkLineHeightViolations(props);
};

var checkLineHeightViolations = function checkLineHeightViolations(props) {
  var rem2px = function rem2px(rem) {
    return parseFloat(rem) * props.fontSize;
  };

  var baseline = props.lineHeight * props.fontSize;

  // Calculate total margin, padding, and border
  var totalMargin = 0;
  if (props.margin) {
    totalMargin = rem2px(props.margin);
  } else {
    totalMargin += rem2px(props.marginTop) || 0;
    totalMargin += rem2px(props.marginBottom) || 0;
  }

  var totalPadding = 0;
  if (props.padding) {
    totalPadding = rem2px(props.padding);
  } else {
    totalPadding += rem2px(props.paddingTop) || 0;
    totalPadding += rem2px(props.paddingBottom) || 0;
  }

  var totalBorder = 0;
  if (props.borderHeight) {
    totalBorder = rem2px(props.borderHeight);
  } else {
    totalBorder += rem2px(props.borderTopHeight) || 0;
    totalBorder += rem2px(props.borderBottomHeight) || 0;
  }

  // Warn the user if the total spacing isn't a multiple of the baseline
  var spacing = totalMargin + totalBorder + totalPadding;
  if (spacing && baseline % spacing !== 0) {
    console.warn('Spacing from padding, border, and margin surrounding element should be a multiple of baseline ' + baseline + '.');
  }
};

// Extract proptypes from the propertiesSpec
var extractPropTypes = function extractPropTypes() {
  var propTypes = {};

  // Loop through all property specs and pluck the prop type
  propertyNames.forEach(function (name) {
    propTypes[name] = propertiesSpec[name].propType;
  });

  return propTypes;
};

Box.propTypes = extractPropTypes();

export default createComponent(styles, Box);


//////////////////
// WEBPACK FOOTER
// ./node_modules/cf-component-box/es/Box.js
// module id = 1019
// module chunks = 0